import(/* webpackMode: "eager" */ "/Users/vrybakk/Documents/Projects/clients/precisionpart-frontend/node_modules/next/dist/client/image-component.js");
